import { render, staticRenderFns } from "./OfferCardSettings.vue?vue&type=template&id=49d91502&"
import script from "./OfferCardSettings.vue?vue&type=script&lang=ts&"
export * from "./OfferCardSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCardSettings.vue?vue&type=style&index=0&id=49d91502&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports